export const WARRANTY_PROGRAM_FORM_DIALOG_ID = 'warrantyProgramFormDialog';
